/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import SectionContainer from 'stories/V1/layouts/SectionContainer'
import EduCapital from 'assets/careers/edu_capital.svg'
import ProjectA from 'assets/careers/project_a.svg'
import RedAlpine from 'assets/careers/redalpine.svg'
import Stride from 'assets/careers/stride.svg'
import EduCapitalMobile from 'assets/careers/edu-capital-mobile.svg'
import ProjectAMobile from 'assets/careers/project-a-mobile.svg'
import RedAlpineMobile from 'assets/careers/redalpine-mobile.svg'
import StrideMobile from 'assets/careers/stride-mobile.svg'
// import Xange from 'assets/careers/xange.svg'
// import XangeMobile from 'assets/careers/xange-mobile.svg'
import Stack from 'components/elements/Stack'
import { Body1 } from 'stories/elements/Typography/Text'

const BackersGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 206px); //repeat(5, 206px);
    place-content: center;
    gap: 8px;
    width: 100%;
    padding: 2.5% 0% 0% 0%;

    @media (max-width: 860px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        /* grid-template-columns: repeat(6, 1fr);
        grid-template-rows: auto auto;
        grid-template-areas:
            'a a b b c c'
            'd d d e e e'; */
    }
`

const BackerCard = styled.div`
    background: ${theme.colors.white};
    border-radius: 24px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    height: 160px;
    transition: transform 0.3s ease;

    &:hover {
        transform: translateY(-5px);
    }

    .backer-logo {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .backer-mobile-logo {
        display: none;
    }

    @media (max-width: 860px) {
        .backer-logo {
            display: none;
        }
        .backer-mobile-logo {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        border-radius: 20px;
        height: 120px;
        padding: 15px;
        /* &:nth-child(1) {
            grid-area: a;
        }
        &:nth-child(2) {
            grid-area: b;
        }
        &:nth-child(3) {
            grid-area: c;
        }
        &:nth-child(4) {
            grid-area: d;
        }
        &:nth-child(5) {
            grid-area: e;
        } */
        height: 80px;
    }
`

const AngelsContainer = styled.div`
    width: 100%;
    max-width: 928px;
    border-radius: 24px;
    background: transparent;
    padding: 24px;
    margin: 24px auto 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
`

const AngelsTitle = styled(Body1)`
    font-family: var(--font-inter);
    font-size: 30px;
    font-weight: 650;
    line-height: 36px;
    letter-spacing: -0.4px;
    color: #f9f9f9;
    margin-bottom: 8px;
    text-align: center;

    @media (max-width: 860px) {
        font-size: 23px;
        line-height: 28px;
        letter-spacing: -0.2px;
    }
`

const AngelsText = styled(Body1)`
    font-family: var(--font-inter);
    font-size: 20px;
    font-weight: 650;
    line-height: 24px;
    letter-spacing: 0;
    color: #b6b4eb;
    text-align: center;

    @media (max-width: 860px) {
        font-size: 17px;
        line-height: 20px;
        letter-spacing: 0.3px;
    }
`

const CareersBackers = () => {
    const backers = [
        // {
        //     name: 'Xange',
        //     logo: <Xange />,
        //     mobileLogo: <XangeMobile />,
        // },
        {
            name: 'RedAlpine',
            logo: <RedAlpine />,
            mobileLogo: <RedAlpineMobile />,
        },
        {
            name: 'Stride',
            logo: <Stride />,
            mobileLogo: <StrideMobile />,
        },
        {
            name: 'Project A',
            logo: <ProjectA />,
            mobileLogo: <ProjectAMobile />,
        },
        {
            name: 'EduCapital',
            logo: <EduCapital />,
            mobileLogo: <EduCapitalMobile />,
        },
    ]

    return (
        <SectionContainer
            title={'Backed by Leading European Investors'}
            backgroundColor="#14183A"
            borderRadius="48px"
            mobileBorderRadius="32px"
        >
            <Stack gutter={0}>
                <BackersGrid>
                    {backers.map((backer, index) => (
                        <BackerCard key={index}>
                            <div className="backer-logo">{backer.logo}</div>
                            <div className="backer-mobile-logo">{backer.mobileLogo}</div>
                        </BackerCard>
                    ))}
                </BackersGrid>

                <AngelsContainer>
                    <AngelsTitle>Angels</AngelsTitle>
                    <AngelsText>
                        Mario Götze, Verena Pausder, founders of companies such as Booking.com, Preply & others
                    </AngelsText>
                </AngelsContainer>
            </Stack>
        </SectionContainer>
    )
}

export default CareersBackers
